'use strict'

import './BlogListVertical.css'
import React, { useEffect, useState } from 'react'
import Pagen from '../../pagen/Pagen'

function BlogListVertical (props) {
  const [clientWidth, setClientWidth] = useState(window.document.documentElement.clientWidth)

  // Save client width
  useEffect(() => {
    // установка ширины экрана клиента
    window.addEventListener('resize', event => setClientWidth(window.document.documentElement.clientWidth))
  }, [])

  const scrollToBlogRoot = () => {
    const blogRubricRoot = document.getElementById('blog-rubric-root');
    if (blogRubricRoot) {
        blogRubricRoot.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handleRubricClick = (rubricID, rubricCode, event) => {
    event.preventDefault(); // Предотвращаем стандартное действие перехода по ссылке

    const url = new URL(window.location.href);

    const newsIndex = url.pathname.indexOf('/news/');
    if (newsIndex !== -1) {
        url.pathname = url.pathname.substring(0, newsIndex + 6); // +6 чтобы включить "/news/"
        url.search = '';
        url.hash = '';
    }

    // Если "select" отсутствует, просто добавляем "id" в конец пути
    if (rubricCode) {
        url.pathname = `${url.pathname}rubric_${rubricCode}/`;
    }

    const newUrl = url.toString();

    // Добавляем текущий URL в историю
    window.history.pushState({ url: newUrl }, null, newUrl);

    scrollToBlogRoot();

    props.setLangLink(url.pathname);
    props.onRubricsChange(rubricID);
  }

  const handleAuthorClick = (aurthorID, event) => {
    event.preventDefault(); // Предотвращаем стандартное действие перехода по ссылке

    const url = new URL(window.location.href);

    const newsIndex = url.pathname.indexOf('/news/');
    if (newsIndex !== -1) {
      url.pathname = url.pathname.substring(0, newsIndex + 6); // +6 чтобы включить "/news/"
      url.search = '';
      url.hash = '';
    }

    if (aurthorID) {
      url.pathname = `${url.pathname}author/${aurthorID}/`;
    }

    const newUrl = url.toString();

    // Добавляем текущий URL в историю
    window.history.pushState({ url: newUrl }, null, newUrl);

    scrollToBlogRoot();

    props.setLangLink(url.pathname);
    props.onAuthorChange(aurthorID);
 }

  return (
    <>
        {
            props.authorInfo ?
                <div className="author-info">
                    <div className="author-info-intro">
                        <div className="author-info__pic">
                            <img src={props.authorInfo.UF_FILE} alt={props.authorInfo.UF_NAME}/>
                        </div>
                        <div className="author-info-text-mob">
                            <div className="author-info__name">{props.authorInfo.UF_NAME}</div>
                            <div className="author-info__activities">{props.authorInfo.UF_DESCRIPTION}</div>
                        </div>
                    </div>
                    <div className="author-info-text">
                        <div className="author-info__name">{props.authorInfo.UF_NAME}</div>
                        <div className="author-info__activities">{props.authorInfo.UF_DESCRIPTION}</div>
                        <div className="author-info__descr">{props.authorInfo.UF_FULL_DESCRIPTION}</div>
                    </div>
                    <script
                        type="application/ld+json"
                        dangerouslySetInnerHTML={{
                            // TEH-1606 (F35): экранируем '<' — иначе '</script>' в URL/полях
                            // разрывает скрипт-элемент (JSON.stringify его не кодирует)
                            __html: JSON.stringify({
                                "@context": "http://schema.org/",
                                "@type": "Person",
                                "name": props.authorInfo.UF_NAME,
                                "alternateName": props.authorInfo.UF_NAME,
                                "url": window.location.href,
                                "image": props.authorInfo.UF_FILE,
                                "jobTitle": props.authorInfo.UF_DESCRIPTION,
                                "worksFor": {
                                    "@type": "Organization",
                                    "name": props.authorInfo.UF_ORGANIZATION
                                }
                            }).replace(/</g, '\\u003c')
                        }}
                    />
                </div>
                :
                <></>
        }
      <div className="author-blog-list">
        {
          props.items.map(item => {
            return <div className="blog-list__item" key={item.ID}>
              <div className="blog-item__img">
                <a href={item.DETAIL_PAGE_URL}>
                    {
                      item.hasOwnProperty('PREVIEW_PICTURE') && item.PREVIEW_PICTURE.hasOwnProperty('CONVERTED_SRC') ?
                        <source srcSet={item.PREVIEW_PICTURE.CONVERTED_SRC} type="image/webp"/> :
                        <></>
                    }
                    <img src={item.PREVIEW_PICTURE.SRC}
                         alt={item.NAME}
                         title={`${item.NAME} - Техно Їжак`} loading="lazy"/>
                </a>
              </div>
              <div className="blog-item__description">
                <div className="blog-item-info__row">
                  {
                    item.hasOwnProperty('DISPLAY_PROPERTIES') && item.DISPLAY_PROPERTIES.hasOwnProperty('RUBRIC') &&
                    typeof item.DISPLAY_PROPERTIES.RUBRIC.DISPLAY_VALUE === 'string' && item.DISPLAY_PROPERTIES.RUBRIC.DISPLAY_VALUE.length ?
                      <a
                          className="blog-item__rubric"
                          href={`/rubric_${item.DISPLAY_PROPERTIES.RUBRIC.LINK}/`}
                          onClick={(event) => handleRubricClick(item.DISPLAY_PROPERTIES.RUBRIC.VALUE, item.DISPLAY_PROPERTIES.RUBRIC.LINK, event)}
                          rel={'nofollow'}
                      >
                        {item.DISPLAY_PROPERTIES.RUBRIC.DISPLAY_VALUE}
                      </a> :
                      <></>
                  }
                  <span className="blog-item__date">{item.date_str}</span>
                  <div className="blog-item__counter">
                    <i className="icon"/>
                    <span>{item.FIELDS.SHOW_COUNTER}</span>
                  </div>
                </div>
                {
                  item.PROPERTIES.hasOwnProperty('BLOG_AUTHOR') && item.PROPERTIES.BLOG_AUTHOR.hasOwnProperty('VALUE')
                  && props.authors.hasOwnProperty(item.PROPERTIES.BLOG_AUTHOR.VALUE) ?
                    <div className="blog-item__author">
                      <svg width="12" height="13">
                        <use xlinkHref="#user-ico"/>
                      </svg>
                      <span className="author-name">
                        <a className="blog-item__rubric"
                           href={`/news/author/${props.authors[item.PROPERTIES.BLOG_AUTHOR.VALUE]['UF_CODE']}/`}
                           onClick={(event) => handleAuthorClick(props.authors[item.PROPERTIES.BLOG_AUTHOR.VALUE]['UF_CODE'], event)}
                           rel={'nofollow'}
                        >
                            {props.authors[item.PROPERTIES.BLOG_AUTHOR.VALUE]['UF_NAME']}
                        </a>
                      </span>
                    </div> :
                    <></>
                }
                <div className="blog-item__title">
                  <a href={item.DETAIL_PAGE_URL}>{item.NAME}</a>
                </div>
                <div
                  className="blog-item__text">{clientWidth < 768 ? item.preview_text_small : item.preview_text_medium}</div>
              </div>
            </div>
          })
        }
      </div>
      <div className="blog-paging"><div className="paging-panel"><Pagen {...props.nav} onPagerChange={props.onPagerChange} setLangLink={props.setLangLink}/></div></div>
    </>
  )
}

export default BlogListVertical